module.exports = __webpack_public_path__ + "img/im_mockup_01.d7839f8e.png";